import { APP_TOKEN } from '../constants';
import { jwtDecode } from 'jwt-decode';

export const getTokenExpiration = (token) => {
  try {
    if (!token) return null;
    const decoded = jwtDecode(token);
    if (!decoded.exp) return null;

    return new Date(decoded.exp * 1000);
  } catch (error) {
    console.error('Invalid token', error);
    return null;
  }
};

export const saveToken = (value) => {
  localStorage.setItem(APP_TOKEN, value);
};

export const getToken = () => localStorage.getItem(APP_TOKEN);

export const removeToken = () => {
  localStorage.removeItem(APP_TOKEN);
};
